class ProductCompleteLook extends HTMLElement {
  constructor() {
    super();
    // 初始化元素的状态或属性
  }

  connectedCallback() {
    // 元素被添加到DOM时调用
    this.init();
  }

  disconnectedCallback() {
    // 元素从DOM中移除时调用
    this.destroySlick($(this.querySelector('.prolist-wrapper')));
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      if(this.dataset.hasprolist && this.querySelectorAll('.prolist-wrapper .pro-item').length > 0) {
        this.initSlick($(this.querySelector(`.prolist-wrapper`)));
      } else {
        this.loadProductRecommendationsIntoSection(this);
      }
    });
  }

  loadProductRecommendationsIntoSection(pclSection = this) {
    if (pclSection === null) {return;}
    let productId = pclSection.dataset.productId;
    let limit = pclSection.dataset.limit;
    let sectionId = pclSection.dataset.setionid;
    let requestUrl = `/recommendations/products?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;
    let request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        if($(container.querySelector(`.pcl-prolist-container`)).find(`.pro-item`).length > 0) {
          pclSection.querySelector(`.pcl-prolist-container`).innerHTML = container.querySelector(`.pcl-prolist-container`).innerHTML;
          if (typeof window.applyEnglishItemSwatches === 'function') {
            window.applyEnglishItemSwatches(pclSection);
          }
          this.initSlick($(pclSection).find(`.prolist-wrapper`));
        }else {
          let targetId = $(pclSection).attr('id');
          $(pclSection).addClass(`hide`);
          $(`.stb__item-list [data-target-id='${targetId}']`).parent().remove();
        }
      }
    };
    request.send();
  };

  initSlick(pclWrapper = $(this.querySelector('.prolist-wrapper'))) {
    pclWrapper.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="product-alsolike-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="product-alsolike-prev">Prev Product</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="product-alsolike-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="product-alsolike-next">NextProduct</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }

  destroySlick(pclWrapper = $(this.querySelector('.prolist-wrapper'))) {
    if (pclWrapper.hasClass('slick-initialized')) {
      pclWrapper.slick('unslick');
    }
  }
}

// 注册自定义元素
customElements.define("product-complete-look", ProductCompleteLook);
